/* Rising Sun FPV - Paint brand converter (sections/rs-paint-converter.liquid): pick a paint, see the
   closest colours in every other brand we stock. sRGB -> CIELAB (D65) -> CIEDE2000 "dE"; Lab is worked out once per paint.
   Data: the Find my colour feed, /collections/<handle>?section_id=paint-data&page=N (sections/paint-data.liquid). Row:
   [variantId, url, title, vendor, productType, "#rrggbb", priceInCents, available, imageUrl]
   Vanilla JS, no libraries, no storage, no third-party requests. */
(function () {
'use strict';

/* ===== CONFIG: how matching works (README.md explains each part) ===== */
var CONFIG = {
  perBrand: 3, // suggestions for each other brand
  similar: 10, // a same-kind paint under this dE means only same-kind paints are shown

  // Labels by CIEDE2000 dE (lower is closer; about 1 is the smallest difference most eyes see)
  closeness: [[2, 'Near match'], [5, 'Close'], [10, 'Similar'], [Infinity, 'Nearest we have']],

  // When other kinds are shown they rank by dE plus this, so a related kind wins a close call
  penalty: { related: 2, other: 5 },

  // Shopify vendor -> brand name shoppers know (others show as-is)
  brandNames: {
    'Games Workshop': 'Citadel',
    'The Army Painter': 'Army Painter',
    'AMMO by MIG': 'AMMO',
    'The Scale Modellers Supply': 'SMS',
    'Acrylicos Vallejo': 'Vallejo'
  },
  defaultBrand: 'Citadel', // selected when the page opens

  // Paint kinds; "related" = next best kinds when nothing of the same kind is close
  kinds: {
    onecoat:   { label: 'One-coat', related: ['wash', 'standard', 'air'] },
    wash:      { label: 'Wash / shade', related: ['onecoat'] },
    technical: { label: 'Technical / texture', related: [] },
    effect:    { label: 'Effect', related: ['metallic'] },
    metallic:  { label: 'Metallic', related: ['effect'] },
    spray:     { label: 'Primer / spray', related: ['standard', 'air'] },
    air:       { label: 'Airbrush', related: ['standard', 'spray'] },
    standard:  { label: 'Standard acrylic', related: ['air', 'spray'] }
  },

  // Keyword rules, tested top to bottom on the title (or the product type if marked 'type').
  // The FIRST match is the kind; later matches are extra tags (a metallic Speedpaint is
  // one-coat, tagged metallic). No match = 'standard'. Keep 'skip' first: mediums,
  // varnishes, thinners, sets and tools aren't colours, so they're left out.
  rules: [
    ['skip', /\b(varnish|thinners?|additive|sealer|fixer|stripper|retarder|stormshield|ardcoat|masking|cleaner|sets?|starter|nippers|clips|holder|flock)\b|\b(lahmian|contrast|speedpaint|glaze|flow|matt|gloss|satin|airbrush|texture) medium\b|\b(gloss|flat|satin|matt|super|ultra) clear\b|\bclear (gloss|flat|satin|matt|coat)\b|\+ ?paints?\b|mixing bottle|assembly stand|spray stick/i],
    ['onecoat', /\b(contrast|speed ?paint|xpress ?colou?r|one[- ]?coat|quick ?gen)\b/i],
    ['wash', /\b(shade|wash(es)?|inks?|filters?|panel ?liner|glaze|streaking)\b/i],
    ['technical', /\b(technical|textured?|crackle|paste|pigments?|weathering|engine oil|fuel stains?|(wet|dust) effects?|deposit|rain ?marks)\b/i],
    ['effect', /\b(colou?r ?shift|holo ?shift|chameleon|chroma ?flame|crystal|prismatic|flip|candy|flake|fluro|furo|neon|glow in the dark|ultra glow|luminous|uv reactive|transparent|clear)\b|\bfluor/i],
    ['metallic', /\b(metal(lic)?s?|gun ?metal|chrome(?! yellow)|silver(?! gr[ae]y)|gold(?! ?(yellow|gelb))|bronze|brass|copper|steel(?! legion)|iron(breaker)?|alumin(i)?um|titanium|platinum|pewter|alloy|pearl|mica|leadbelcher|retributor|warplock|screaming bell|sigmarite|necron compound)\b|hyperchrome/i],
    ['spray', /\b(spray|aerosol|primer|surfacer|undercoat)\b/i],
    ['air', /\b(citadel air|(model|game|metal) air|airbrush)\b|\bair ?:/i],
    ['technical', /weathering|effects/i, 'type'],
    ['air', /airbrush/i, 'type']
  ]
};

var d = document, MAX = 60, DE = 'ΔE'; // MAX = options listed at once

/* colour maths */
function hexToLab(hex) {
  var n = parseInt(hex.slice(1), 16), c = [n >> 16 & 255, n >> 8 & 255, n & 255].map(function (v) {
    v /= 255;
    return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  function f(t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; }
  var fx = f((c[0] * 0.4124564 + c[1] * 0.3575761 + c[2] * 0.1804375) / 0.95047),
    fy = f(c[0] * 0.2126729 + c[1] * 0.7151522 + c[2] * 0.0721750),
    fz = f((c[0] * 0.0193339 + c[1] * 0.1191920 + c[2] * 0.9503041) / 1.08883);
  return [116 * fy - 16, 500 * (fx - fy), 200 * (fy - fz)];
}
var RAD = Math.PI / 180, P25 = Math.pow(25, 7);
function de2000(a, b) {
  var Cm = (Math.sqrt(a[1] * a[1] + a[2] * a[2]) + Math.sqrt(b[1] * b[1] + b[2] * b[2])) / 2, Cm7 = Math.pow(Cm, 7);
  var G = 1.5 - 0.5 * Math.sqrt(Cm7 / (Cm7 + P25)), a1 = G * a[1], a2 = G * b[1];
  var C1 = Math.sqrt(a1 * a1 + a[2] * a[2]), C2 = Math.sqrt(a2 * a2 + b[2] * b[2]), CC = C1 * C2;
  var h1 = Math.atan2(a[2], a1) / RAD, h2 = Math.atan2(b[2], a2) / RAD, dh = 0;
  if (h1 < 0) h1 += 360;
  if (h2 < 0) h2 += 360;
  var hm = h1 + h2;
  if (CC) {
    dh = h2 - h1;
    if (dh > 180) dh -= 360; else if (dh < -180) dh += 360;
    hm = Math.abs(h1 - h2) > 180 ? (hm + (hm < 360 ? 360 : -360)) / 2 : hm / 2;
  }
  var Lm = (a[0] + b[0]) / 2 - 50, Cp = (C1 + C2) / 2, Cp7 = Math.pow(Cp, 7);
  var T = 1 - 0.17 * Math.cos((hm - 30) * RAD) + 0.24 * Math.cos(2 * hm * RAD) + 0.32 * Math.cos((3 * hm + 6) * RAD) - 0.2 * Math.cos((4 * hm - 63) * RAD);
  var l = (b[0] - a[0]) / (1 + 0.015 * Lm * Lm / Math.sqrt(20 + Lm * Lm)),
    c = (C2 - C1) / (1 + 0.045 * Cp),
    h = 2 * Math.sqrt(CC) * Math.sin(dh * RAD / 2) / (1 + 0.015 * Cp * T),
    RT = -2 * Math.sqrt(Cp7 / (Cp7 + P25)) * Math.sin(60 * Math.exp(-Math.pow((hm - 275) / 25, 2)) * RAD);
  return Math.sqrt(l * l + c * c + h * h + RT * c * h);
}

/* kind and tidy name from the title */
function classify(title, type) {
  var tags = [];
  for (var i = 0, r; i < CONFIG.rules.length; i++) {
    r = CONFIG.rules[i];
    if (r[1].test(r[2] === 'type' ? type : title)) {
      if (r[0] === 'skip') { if (!tags.length) return null; }
      else if (tags.indexOf(r[0]) < 0) tags.push(r[0]);
    }
  }
  return tags.length ? tags : ['standard'];
}
// "21-03 Citadel Base: Mephiston Red (12ml)" -> name "Mephiston Red", range "Base"
var NAMES = [ // [pattern, name group, range group or fixed range text]
  [/^(?:\d+-\d+\s+)?Citadel\s+(Spray Paint|Base|Layer|Dry|Technical|Contrast|Shade|Air)\s*:\s*(.+)$/i, 2, 1],
  [/^Army Painter\s+(Speedpaint(?:\s+2\.0)?)\s*-\s*(.+)$/i, 2, 1],
  [/^Army Painter\s+Aerosol Spray Primer\s*-\s*(.+)$/i, 1, 'Spray primer'],
  [/^Army Painter\s*-\s*(Quick Shade)\s*-\s*(.+)$/i, 2, 1],
  [/^FIGURES PAINTS\s+(.+)$/i, 1, 'Figures'],
  [/^(.+?)\s*\((Playmarker)\)$/i, 1, 2],
  [/^Bifrost Airbrush(?:\s+Paints?)?\s*-\s*(.+)$/i, 1, ''],
  [/^AK Interactive\s*-?\s*(.+?)\s+-\s+(.+)$/i, 2, 1],
  [/^(?:SMS\s+)?((?:[A-Z][a-z]+\s+)+)([A-Z0-9](?![a-z]).*)$/, 2, 1] // SMS: "Premium INSIGNIA WHITE"
];
var KEEP = /^(RAF|RAAF|RAN|IJN|IJA|US|USAF|USMC|NZ|HK|AN|VR|PN|QR|QGR|NSWGR|SECR|PTC|GWR|LNER|LNWR|LMS|SR|BR|BSC|SCC|CARC|MOD|SAC|UV|NATO|RLM|RAL|FS|BS|HDT|HSV|IDF|DAK|WWI|WWII|CSX|MKII|ECSTAR|AUSCAM|XV)$/,
  SMALL = /^(a|an|and|at|for|in|of|on|or|the|to|with)$/i;
function tidy(s) { // "INSIGNIA WHITE FS17875" -> "Insignia White FS17875"
  var first = true;
  return s.replace(/[A-Za-z0-9]+/g, function (w) {
    var out = w;
    if (w.length > 1 && !/\d/.test(w) && w === w.toUpperCase() && !KEEP.test(w)) {
      out = !first && SMALL.test(w) ? w.toLowerCase() : w.charAt(0) + w.slice(1).toLowerCase();
    }
    first = false;
    return out;
  });
}
function nameOf(title) {
  var t = String(title).replace(/\(?\b\d+(?:\.\d+)?\s*(?:ml|mm)\b\)?/gi, ' ').replace(/\s+/g, ' ').trim();
  for (var i = 0, m, r; i < NAMES.length; i++) {
    r = NAMES[i];
    if ((m = t.match(r[0]))) {
      return { name: tidy(m[r[1]].trim()), range: (typeof r[2] === 'number' ? tidy(m[r[2]].trim()) : r[2]).replace(/^Spray Paint$/i, 'Spray') };
    }
  }
  return { name: tidy(t.replace(/^SMS\s+/i, '')), range: '' };
}

/* helpers */
function esc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
}
function norm(s) {
  s = String(s || '').toLowerCase();
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
}
function money(cents) { return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
function plural(n, w) { return n.toLocaleString('en-AU') + ' ' + w + (n === 1 ? '' : 's'); }
function kindLabel(k) { return (CONFIG.kinds[k] || CONFIG.kinds.standard).label; }
function closeIndex(dE) {
  for (var i = 0; i < CONFIG.closeness.length - 1; i++) if (dE < CONFIG.closeness[i][0]) return i;
  return CONFIG.closeness.length - 1;
}
function gauge(dE) { // 5 lit segments for a near match, down to 1 for a far one
  var lit = Math.max(1, 5 - closeIndex(dE) - (dE >= CONFIG.similar * 2 ? 1 : 0)), s = '';
  for (var k = 0; k < 5; k++) s += k < lit ? '<i class="on"></i>' : '<i></i>';
  return s;
}

/* data: every page of the feed, once per collection */
var cache = {};
function fetchPage(feed, n) {
  var ctl = window.AbortController && new AbortController(), timer = ctl && setTimeout(function () { ctl.abort(); }, 20000);
  function done() { clearTimeout(timer); }
  return fetch(feed + (feed.indexOf('?') < 0 ? '?' : '&') + 'section_id=paint-data&page=' + n, { credentials: 'same-origin', signal: ctl && ctl.signal || undefined })
    .then(function (r) {
      if (!r.ok) throw new Error('Feed HTTP ' + r.status);
      return r.text();
    })
    .then(function (html) {
      done();
      var m = html.match(/<script[^>]*data-paint-feed[^>]*>([\s\S]*?)<\/script>/i);
      if (!m) throw new Error('No paint feed');
      return { pages: Math.min(parseInt((m[0].match(/data-pages="(\d+)"/) || [])[1], 10) || 1, 40), rows: JSON.parse(m[1]) };
    }, function (e) { done(); throw e; });
}
function load(feed) {
  if (!cache[feed]) {
    cache[feed] = fetchPage(feed, 1).then(function (first) {
      for (var i = 2, reqs = []; i <= first.pages; i++) reqs.push(fetchPage(feed, i));
      return Promise.all(reqs).then(function (rest) { return build([first].concat(rest)); });
    });
    cache[feed].catch(function () { delete cache[feed]; }); // "Try again" fetches afresh
  }
  return cache[feed];
}
function build(pages) {
  var groups = {}, byId = {}, count = 0;
  pages.forEach(function (pg) {
    (Array.isArray(pg.rows) ? pg.rows : []).forEach(function (a) {
      if (!Array.isArray(a) || !/^#[0-9a-f]{6}$/i.test(a[5] || '') || !a[3] || byId[a[0]]) return;
      var title = String(a[2] || ''), tags = classify(title, String(a[4] || ''));
      if (!tags) return;
      var nm = nameOf(title), brand = CONFIG.brandNames[a[3]] || String(a[3]), p = {
        id: String(a[0]), url: String(a[1] || '#'), brand: brand, hex: a[5].toUpperCase(), price: +a[6] || 0,
        avail: !!a[7], name: nm.name, range: nm.range, kind: tags[0], tags: tags, lab: hexToLab(a[5])
      };
      p.label = p.name + (p.range ? ' (' + p.range + ')' : '');
      p.nname = norm(p.name);
      p.key = norm(p.name + ' ' + p.range + ' ' + title);
      (groups[brand] = groups[brand] || []).push(p);
      byId[p.id] = p;
      count++;
    });
  });
  var brands = Object.keys(groups).map(function (b) {
    return { name: b, paints: groups[b].sort(function (x, y) { return x.label.localeCompare(y.label); }) };
  }).sort(function (x, y) { return x.name.localeCompare(y.name); });
  return { brands: brands, byId: byId, count: count };
}

/* search within one brand: every word must appear; name starts rank first */
function search(brand, q) {
  var words = norm(q).split(' ').filter(Boolean), out = [];
  brand.paints.forEach(function (p) {
    for (var i = 0; i < words.length; i++) if (p.key.indexOf(words[i]) < 0) return;
    out.push([!words.length ? 2 : !p.nname.indexOf(words[0]) ? 0 : (' ' + p.nname).indexOf(' ' + words[0]) > -1 ? 1 : 2, p]);
  });
  return out.sort(function (a, b) { return a[0] - b[0] || a[1].label.localeCompare(b[1].label); }).map(function (x) { return x[1]; });
}

/* conversion: the closest paints in every other brand */
function relation(src, p) { // 0 same kind, 1 related, 2 other
  if (p.kind === src.kind) return 0;
  if (((CONFIG.kinds[src.kind] || {}).related || []).indexOf(p.kind) > -1) return 1;
  for (var i = 0; i < src.tags.length; i++) if (src.tags[i] !== 'standard' && p.tags.indexOf(src.tags[i]) > -1) return 1;
  return 2;
}
function byDist(a, b) { return a.d - b.d || b.p.avail - a.p.avail || a.p.label.localeCompare(b.p.label); }
function convert(data, src, inStockOnly) {
  return data.brands.filter(function (b) { return b.name !== src.brand; }).map(function (b) {
    var pool = [], same = [], kindAll = false, best = Infinity;
    b.paints.forEach(function (p) {
      if (p.kind === src.kind) kindAll = true;
      if (inStockOnly && !p.avail) return;
      var it = { p: p, d: de2000(src.lab, p.lab), rel: relation(src, p) };
      pool.push(it);
      if (!it.rel) same.push(it);
    });
    same.sort(byDist);
    var mixed = !(same.length && same[0].d < CONFIG.similar), list = same;
    if (mixed) {
      pool.forEach(function (it) { it.r = it.d + (it.rel && (it.rel === 1 ? CONFIG.penalty.related : CONFIG.penalty.other)); });
      list = pool.sort(function (x, y) { return x.r - y.r || byDist(x, y); });
    }
    list = list.slice(0, CONFIG.perBrand);
    list.forEach(function (it) { if (it.d < best) best = it.d; });
    return { brand: b, items: list, best: best, mixed: mixed, kindAll: kindAll, kindPool: same.length > 0 };
  }).sort(function (x, y) { return x.best - y.best || x.brand.name.localeCompare(y.brand.name); });
}

function copyText(text) { // the caller shows the link in a text field if this fails
  return navigator.clipboard && window.isSecureContext ? navigator.clipboard.writeText(text) : Promise.reject(new Error('no clipboard'));
}

/* ===== UI: one instance per [data-rpc] section ===== */
function init(root) {
  if (root.getAttribute('data-rpc-ready')) return;
  root.setAttribute('data-rpc-ready', '1');
  function $(s) { return root.querySelector(s); }
  var el = {}; // el.shareOut = [data-share-out], and so on
  'brandset brands q list clear hint count pick status tools instock share shareOut results'.split(' ').forEach(function (k) {
    el[k] = $('[data-' + k.replace('O', '-o') + ']');
  });
  if (!el.brands || !el.q || !el.list || !el.results || !el.status) return;
  var uid = root.getAttribute('data-uid') || 'rpc' + Math.random().toString(36).slice(2, 8),
    feed = root.getAttribute('data-feed') || '/collections/' + (root.getAttribute('data-collection') || 'paint-colour-matcher'),
    hintText = el.hint ? el.hint.textContent : '', DATA = null, brand = null, current = null, matches = [], active = -1, timer = 0;

  function say(msg) { el.status.textContent = msg; }
  function idle(lines, extra) {
    el.results.innerHTML = '<div class="rpc__idle">' + lines.map(function (l, i) {
      return '<p><span class="rpc__prompt" aria-hidden="true">&gt;</span> ' + esc(l) + (i === lines.length - 1 ? '<span class="rpc__cursor" aria-hidden="true"></span>' : '') + '</p>';
    }).join('') + (extra || '') + '</div>';
  }
  function hint(t) { if (el.hint) el.hint.textContent = t; }

  /* brand picker: native radios, so arrow keys work out of the box */
  function findBrand(name) {
    for (var i = 0; i < DATA.brands.length; i++) if (DATA.brands[i].name === name) return DATA.brands[i];
    return null;
  }
  function setBrand(b) {
    brand = b;
    Array.prototype.forEach.call(el.brands.querySelectorAll('input'), function (r) { r.checked = r.value === b.name; });
    el.q.placeholder = 'Search ' + plural(b.paints.length, b.name + ' paint');
    if (!current || current.brand !== b.name) { el.q.value = ''; syncClear(); }
    closeList();
    hint(hintText);
  }
  el.brands.addEventListener('change', function (e) {
    var b = DATA && findBrand(e.target.value);
    if (b) setBrand(b);
  });

  /* paint search: ARIA 1.2 combobox with a listbox popup */
  function syncClear() { if (el.clear) el.clear.hidden = !el.q.value; }
  function openList() {
    if (!el.list.children.length) return closeList();
    el.list.hidden = false;
    el.q.setAttribute('aria-expanded', 'true');
  }
  function closeList() {
    el.list.hidden = true;
    el.q.setAttribute('aria-expanded', 'false');
    el.q.removeAttribute('aria-activedescendant');
    active = -1;
  }
  function mark(name, q) {
    var w = norm(q).split(' ')[0], i = w ? name.toLowerCase().indexOf(w) : -1;
    return i < 0 ? esc(name) : esc(name.slice(0, i)) + '<mark>' + esc(name.slice(i, i + w.length)) + '</mark>' + esc(name.slice(i + w.length));
  }
  function filter() {
    if (!brand) return 0;
    var q = el.q.value, shown = (matches = search(brand, q)).slice(0, MAX);
    el.list.innerHTML = shown.map(function (p, i) {
      return '<li class="rpc__opt" role="option" id="' + uid + '-o' + i + '" aria-selected="false" data-i="' + i + '"><span class="rpc__optsw" style="background:' + p.hex +
        '" aria-hidden="true"></span><span class="rpc__optname">' + mark(p.name, q) + '</span>' + (p.range ? '<span class="rpc__optmeta">' + esc(p.range) + '</span>' : '') + '</li>';
    }).join('');
    active = -1;
    hint(!shown.length ? 'No ' + brand.name + ' paint matches "' + q.trim() + '". Check the spelling or pick another brand.' :
      matches.length > MAX ? 'Showing ' + MAX + ' of ' + matches.length + '. Keep typing to narrow it down.' : hintText);
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (el.count) el.count.textContent = matches.length ? plural(matches.length, 'paint') + ' found. Use the up and down arrows to choose.' : 'No paints found.';
    }, 500);
    return shown.length;
  }
  function setActive(i) {
    var opts = el.list.children, o = opts[i];
    if (opts[active]) opts[active].setAttribute('aria-selected', 'false');
    active = o ? i : -1;
    if (!o) return el.q.removeAttribute('aria-activedescendant');
    o.setAttribute('aria-selected', 'true');
    el.q.setAttribute('aria-activedescendant', o.id);
    if (o.offsetTop < el.list.scrollTop) el.list.scrollTop = o.offsetTop;
    else if (o.offsetTop + o.offsetHeight > el.list.scrollTop + el.list.clientHeight) el.list.scrollTop = o.offsetTop + o.offsetHeight - el.list.clientHeight;
  }
  el.q.addEventListener('input', function () {
    syncClear();
    filter();
    openList();
    setActive(el.q.value.trim() ? 0 : -1);
  });
  el.q.addEventListener('click', function () { if (el.list.hidden && brand) { filter(); openList(); } });
  el.q.addEventListener('focus', function () { // phones: lift the search above the keyboard so the list has room
    if (window.innerWidth >= 640) return;
    setTimeout(function () {
      var f = el.q.closest('.rpc__field') || el.q, vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      if (d.activeElement === el.q && el.q.getBoundingClientRect().top > vh * 0.3) f.scrollIntoView({ block: 'start' });
    }, 350);
  });
  el.q.addEventListener('keydown', function (e) {
    var n = el.list.children.length, k = e.key;
    if (k === 'ArrowDown' || k === 'ArrowUp') {
      e.preventDefault();
      if (el.list.hidden) { n = filter(); openList(); }
      if (!n || e.altKey) return;
      var down = k === 'ArrowDown';
      setActive(active < 0 ? (down ? 0 : n - 1) : (active + (down ? 1 : -1) + n) % n);
    } else if (k === 'Enter') {
      if (!el.list.hidden && active > -1) { e.preventDefault(); choose(matches[active]); }
    } else if (k === 'Escape') {
      if (!el.list.hidden) { e.preventDefault(); closeList(); }
      else if (el.q.value) { e.preventDefault(); el.q.value = ''; syncClear(); }
    } else if (k === 'Tab') {
      closeList();
    }
  });
  el.q.addEventListener('blur', function () { // short delay so a tap on an option still lands
    setTimeout(function () { if (d.activeElement !== el.q) closeList(); }, 150);
  });
  el.list.addEventListener('mousedown', function (e) { e.preventDefault(); }); // keep focus in the search
  el.list.addEventListener('click', function (e) {
    var o = e.target.closest('[data-i]');
    if (o) choose(matches[+o.getAttribute('data-i')]);
  });
  if (el.clear) el.clear.addEventListener('click', function () {
    el.q.value = '';
    syncClear();
    el.q.focus();
    filter();
    openList();
  });

  /* choosing a paint, and the results */
  function choose(p, fromLink) {
    if (!p) return;
    current = p;
    if (!brand || brand.name !== p.brand) setBrand(findBrand(p.brand));
    el.q.value = p.label;
    syncClear();
    closeList();
    renderPick();
    renderResults();
    if (!fromLink && !(window.Shopify && window.Shopify.designMode)) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('paint', p.id);
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (err) { /* old browser: the share button still works */ }
    }
  }
  function stock(p) { return p.avail ? '<span class="rpc__stock is-in">In stock</span>' : '<span class="rpc__stock is-out">Sold out</span>'; }
  function renderPick() {
    var p = current;
    if (!el.pick) return;
    el.pick.innerHTML = '<div class="rpc__picksw" style="background:' + p.hex + '" aria-hidden="true"></div><div><p class="rpc__pickbrand">' + esc(p.brand) +
      '</p><h2 class="rpc__pickname"><a class="rpc__link" href="' + esc(p.url) + '">' + esc(p.name) + '</a></h2><dl class="rpc__readout">' +
      (p.range ? '<div><dt>Range</dt><dd>' + esc(p.range) + '</dd></div>' : '') + '<div><dt>Type</dt><dd>' + esc(kindLabel(p.kind)) +
      '</dd></div><div><dt>Swatch</dt><dd class="rpc__mono">' + p.hex + '</dd></div><div><dt>Price</dt><dd><span class="rpc__mono">' + esc(money(p.price)) + '</span> ' + stock(p) + '</dd></div></dl></div>';
    el.pick.hidden = false;
    if (el.tools) el.tools.hidden = false;
    if (el.shareOut) el.shareOut.hidden = true;
  }
  function card(it, src) {
    var p = it.p, url = esc(p.url);
    return '<li class="rpc__card"><a class="rpc__csw" href="' + url + '" tabindex="-1" aria-hidden="true"><span style="background:' + src.hex + '"></span><span style="background:' + p.hex + '"></span></a>' +
      '<div class="rpc__cbody"><p class="rpc__cname"><a class="rpc__link" href="' + url + '">' + esc(p.name) + '</a></p><p class="rpc__cmeta">' +
      (p.range ? esc(p.range) + ' <span aria-hidden="true">/</span> ' : '') + '<span class="rpc__mono">' + p.hex + '</span></p>' +
      (it.rel ? '<p class="rpc__ckind' + (it.rel === 1 ? ' rpc__ckind--rel">Type: ' : '">Different type: ') + esc(kindLabel(p.kind)) + '</p>' : '') +
      '<p class="rpc__match"><span class="rpc__gauge" aria-hidden="true">' + gauge(it.d) + '</span><b>' + esc(CONFIG.closeness[closeIndex(it.d)][1]) +
      '</b> <span class="rpc__de"><abbr title="Colour difference (CIEDE2000)">' + DE + '</abbr> ' + it.d.toFixed(1) + '</span></p></div>' +
      '<div class="rpc__cfoot"><span class="rpc__price">' + esc(money(p.price)) + '</span>' + stock(p) +
      (p.avail ? '<button type="button" class="rpc__btn rpc__add" data-add="' + esc(p.id) + '">Add to cart<span class="rpc__vh"> ' + esc(p.label + ', ' + p.brand) + '</span></button>' : '') + '</div></li>';
  }
  function group(g, gi, src, inStock) {
    var b = g.brand, kl = kindLabel(src.kind).toLowerCase(), id = uid + '-g' + gi, note = '';
    if (g.items.some(function (it) { return it.rel; })) {
      note = !g.kindAll ? b.name + ' has no ' + kl + ' paints, so the closest of any type are shown.' :
        !g.kindPool ? b.name + '\'s ' + kl + ' paints are sold out, so the closest in-stock paints of other types are shown.' :
          'No ' + kl + ' paint is within the Similar range, so the closest of any type are shown.';
    }
    return '<section class="rpc__group" aria-labelledby="' + id + '"><header class="rpc__ghead"><h3 class="rpc__gname" id="' + id + '">' + esc(b.name) + '</h3>' +
      (g.items.length ? '<p class="rpc__gbest">Closest: ' + esc(CONFIG.closeness[closeIndex(g.best)][1]) + '</p>' : '') + '</header>' +
      (note ? '<p class="rpc__gnote">' + esc(note) + '</p>' : '') +
      (g.items.length ? '<ol class="rpc__cards">' + g.items.map(function (it) { return card(it, src); }).join('') + '</ol>' :
        '<p class="rpc__gnote">No ' + (inStock ? 'in-stock ' : '') + esc(b.name) + ' paints right now.' + (inStock ? ' Turn off In stock only to include sold-out paints.' : '') + '</p>') + '</section>';
  }
  function renderResults() {
    if (!current || !DATA) return;
    var inStock = !el.instock || el.instock.checked, src = current, groups = convert(DATA, src, inStock);
    el.results.innerHTML = groups.length ? '<h2 class="rpc__vh">Closest matches in other brands</h2><p class="rpc__legend">Each swatch shows your paint on the left and the match on the right.</p>' +
      groups.map(function (g, i) { return group(g, i, src, inStock); }).join('') : '<p class="rpc__gnote">We only stock one paint brand right now, so there\'s nothing to convert to.</p>';
    say('Closest matches to ' + src.brand + ' ' + src.label + ' from ' + plural(groups.length, 'other brand') + (inStock ? ', in stock only.' : '.'));
  }
  if (el.instock) el.instock.addEventListener('change', renderResults);

  /* share link */
  if (el.share) el.share.addEventListener('click', function () {
    if (!current) return;
    var url = location.origin + location.pathname + '?paint=' + encodeURIComponent(current.id), btn = el.share, old = btn.textContent;
    copyText(url).then(function () {
      btn.textContent = 'Link copied';
      say('Link to this conversion copied.');
      setTimeout(function () { btn.textContent = old; }, 2000);
    }, function () {
      var input = el.shareOut && el.shareOut.querySelector('input');
      if (input) {
        el.shareOut.hidden = false;
        input.value = url;
        input.focus();
        input.select();
      }
      say('Copy the link below to share this conversion.');
    });
  });

  /* add to cart: same call and cart refresh as Find my colour */
  root.addEventListener('click', function (e) {
    var add = e.target.closest('button[data-add]');
    if (e.target.closest('[data-retry]')) return start();
    if (!add) return;
    var p = DATA && DATA.byId[add.getAttribute('data-add')], label = add.firstChild;
    function reset(t, ms) { setTimeout(function () { label.nodeValue = 'Add to cart'; add.disabled = false; }, ms); label.nodeValue = t; }
    add.disabled = true;
    label.nodeValue = 'Adding…';
    fetch((window.routes && window.routes.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: +add.getAttribute('data-add'), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        reset('Added', 1800);
        say('Added ' + (p ? p.brand + ' ' + p.label : 'the paint') + ' to your cart.');
        d.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
        d.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1 } }));
      })
      .catch(function () {
        reset('Could not add', 2000);
        say('That paint could not be added to your cart. It may have just sold out.');
      });
  });

  /* start-up */
  function start() {
    say('Loading the paint list…');
    idle(['Loading paint index']);
    el.results.setAttribute('aria-busy', 'true');
    load(feed).then(function (data) {
      el.results.setAttribute('aria-busy', 'false');
      DATA = data;
      if (!data.brands.length) {
        say('No paints are set up for the converter yet.');
        return idle(['No paints found', 'Ask the crew in store for a colour match']);
      }
      var want = new URLSearchParams(location.search).get('paint'), linked = want && data.byId[want];
      brand = linked ? findBrand(linked.brand) : findBrand(CONFIG.defaultBrand) || data.brands[0];
      el.brands.innerHTML = data.brands.map(function (b) {
        return '<label class="rpc__chip"><input type="radio" name="' + uid + '-brand" value="' + esc(b.name) + '"><span>' + esc(b.name) + ' <em>' + b.paints.length + '</em></span></label>';
      }).join('');
      if (el.brandset) el.brandset.disabled = false;
      el.q.disabled = false;
      setBrand(brand);
      if (linked) return choose(linked, true);
      idle(['Pick your brand, then type part of the paint name', 'We\'ll line up the closest colours from every other brand']);
      say(want ? 'That shared paint isn\'t in our list any more. Pick a paint to convert.' :
        plural(data.count, 'paint') + ' from ' + plural(data.brands.length, 'brand') + ' ready to convert.');
    }, function () {
      el.results.setAttribute('aria-busy', 'false');
      say('The paint list didn\'t load. Check your connection, then try again.');
      idle(['Paint list offline', 'Check your connection, then try again'], '<button type="button" class="rpc__btn" data-retry>Try again</button>');
    });
  }
  start();
}

function initAll(scope) { Array.prototype.forEach.call((scope || d).querySelectorAll('[data-rpc]'), init); }
if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { initAll(d); });
else initAll(d);
d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

/* for tests and tuning in the browser console */
window.RSPaintConverter = { CONFIG: CONFIG, de2000: de2000, hexToLab: hexToLab, classify: classify, nameOf: nameOf, build: build, convert: convert, search: search };
})();